module.exports = __webpack_public_path__ + "8d7536fc3e83fd66bc5f10ae09b2e19d.MP3";